/**
 * Browser Info
 *
 * @authors lijie44@baidu.com
 * @date  2023-5-17 16:18:30
 */

export interface ISystemInfo {
    isAndroid: boolean;
    isIOS: boolean;
    isSafari: boolean;
    isChrome: boolean;
    isFirefox: boolean;
    isSamsung: boolean;
    isWeixin: boolean;
    weixinVersion: string;
    isIPad: boolean;
    isWeiBo: boolean;
    isQQ: boolean;
    isBaidu: boolean;
    isUC: boolean;
  }

export const systemInfo = (): ISystemInfo => {
    const u = window.navigator ? window.navigator.userAgent : navigator.userAgent;
    const chrome = u.indexOf('Chrome') || -1;

    // 是否Baiduapp主板
    const isBaidu = / baiduboxapp\//i.test(u) && !/ (lite|info|pro|mission) baiduboxapp/.test(u);
    // 是否是android
    const isAndroid = u.includes('Android') || u.includes('Adr') || u.includes('android');
    // 是否是ios
    const isIOS = !!(/\(i[^;]+;( U;)? CPU.+Mac OS X/.exec(u));
    const isSafari = /^((?!chrome|android).)*safari/i.test(u);
    const isUC = /ucbrowser/i.test(u);
    // 是否是chrome
    const isChrome = chrome > 0;
    const isFirefox = u.includes('Firefox');
    // 是否是三星浏览器
    const isSamsung = u.includes('SamsungBrowser');
    // 判断是否是微信
    const isWeixin = /micromessenger/i.test(u);
    const isQQ = /QQ\//i.test(u); // qq
    const isWeiBo = /weibo/gi.test(u); // 微博
    const isIPad
      = !!(/(iPad)/.exec(navigator.userAgent))
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    // 微信版本
    const weixinVersion = (function () {
        let version: any[] = [];

        try {
            version
          = (/micromessenger\/(\d+\.\d+\.\d+)/i.exec(navigator.appVersion)) || [];
        }
        catch (err) {
            version = [];
        }

        return version[1] || '';
    })();

    return {
        isAndroid,
        isIOS,
        isSafari,
        isChrome,
        isFirefox,
        isWeixin,
        isSamsung,
        weixinVersion,
        isIPad,
        isQQ,
        isWeiBo,
        isBaidu,
        isUC,
    };
};
